import { normalizeAssetKey } from './assets';

export const DEFAULT_FOCUS_COLLAPSED_COUNT = 3;
export const MAX_PRIORITY_FOCUS_COUNT = 3;

const getComparableFocusKeys = (item) =>
  [
    item?.answerCode,
    item?.code,
    item?.focusAreaCode,
    item?.name,
    item?.label,
    item?.answer,
    item?.displayName,
  ]
    .filter((value) => value !== undefined && value !== null && value !== '')
    .map((value) => normalizeAssetKey(value));

export const orderFocusAreasByPriority = (focusAreas, priorityFocus) => {
  if (!Array.isArray(focusAreas) || focusAreas.length === 0) return [];
  if (!Array.isArray(priorityFocus) || priorityFocus.length === 0) return focusAreas;

  const rankedPriority = [...priorityFocus]
    .filter((item) => item && typeof item === 'object')
    .sort((a, b) => Number(a.rank || 0) - Number(b.rank || 0));
  const usedIndexes = new Set();

  const prioritizedFocusAreas = rankedPriority
    .map((priorityItem) => {
      const priorityKeys = new Set(getComparableFocusKeys(priorityItem));
      const matchedIndex = focusAreas.findIndex(
        (focusAreaItem, index) =>
          !usedIndexes.has(index) &&
          getComparableFocusKeys(focusAreaItem).some((key) => priorityKeys.has(key)),
      );

      if (matchedIndex < 0) return null;
      usedIndexes.add(matchedIndex);
      return focusAreas[matchedIndex];
    })
    .filter(Boolean);

  return [
    ...prioritizedFocusAreas,
    ...focusAreas.filter((_, index) => !usedIndexes.has(index)),
  ];
};
